var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFamilyBusiness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 411.26 276.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".family-cls{fill:none;stroke:#367c2b;stroke-linecap:round;stroke-linejoin:round;stroke-width:11.26px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "family-cls",
    points: "30.68 91.83 30.68 270.55 377.6 270.55 377.6 91.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "family-cls",
    d: "M405.11,58.9,382.32,13.33a13.9,13.9,0,0,0-12.44-7.7h-329a13.9,13.9,0,0,0-12.45,7.7L5.63,58.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "family-cls",
    d: "M55.57,59.76v7.46a25,25,0,0,1-25,25h0a25,25,0,0,1-25-25V58.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "family-cls",
    d: "M105.5,59.76v7.46a25,25,0,0,1-25,25h0a25,25,0,0,1-25-25V58.9L72.21,9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "family-cls",
    d: "M155.44,59.76v7.46a25,25,0,0,1-25,25h0a25,25,0,0,1-25-25V58.9L118.82,6.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "family-cls",
    d: "M205.37,59.76v7.46a25,25,0,0,1-25,25h0a25,25,0,0,1-25-25V58.9l4.34-52.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "family-cls",
    d: "M255.31,59.76v7.46a25,25,0,0,1-25,25h0a25,25,0,0,1-25-25V6.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "family-cls",
    d: "M305.24,59.76v7.46a25,25,0,0,1-25,25h0a25,25,0,0,1-25-25V58.9L252,9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "family-cls",
    d: "M355.18,59.76v7.46a25,25,0,0,1-25,25h0a25,25,0,0,1-25-25V58.9L298.58,6.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "family-cls",
    d: "M405.11,59.76v7.46a25,25,0,0,1-25,25h0a25,25,0,0,1-25-25V58.9L341.5,6.79"
  }), /*#__PURE__*/React.createElement("line", {
    className: "family-cls",
    x1: 30.68,
    y1: 270.55,
    x2: 6.15,
    y2: 270.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "family-cls",
    x1: 405.63,
    y1: 270.55,
    x2: 377.6,
    y2: 270.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "family-cls",
    x: 55.21,
    y: 116.36,
    width: 175.21,
    height: 101.62
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "family-cls",
    points: "272.47 267.04 272.47 151.41 349.56 151.41 349.56 267.04"
  }), /*#__PURE__*/React.createElement("line", {
    className: "family-cls",
    x1: 286.49,
    y1: 200.46,
    x2: 286.49,
    y2: 210.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "family-cls",
    x1: 202.04,
    y1: 115.49,
    x2: 175.41,
    y2: 142.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "family-cls",
    x1: 222.02,
    y1: 115.49,
    x2: 178.74,
    y2: 158.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "family-cls",
    x1: 55.89,
    y1: 205.12,
    x2: 82.23,
    y2: 178.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "family-cls",
    x1: 55.89,
    y1: 185.14,
    x2: 82.23,
    y2: 158.8
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyBusiness);
export default __webpack_public_path__ + "static/media/family_business.720802576e228d6ef2f17d06550db164.svg";
export { ForwardRef as ReactComponent };